<ng-container *ngIf="ratios && colors; else singleBar">
  <ng-container *ngFor="let ratio of ratios; let i = index">
    <div *ngIf="ratio > 0" class="consumption-bar"
      [style.backgroundColor]="colors[i]"
      [style.width.%]="ratio * 100">
    </div>
  </ng-container>
</ng-container>

<ng-template #singleBar>
  <div class="consumption-bar"
    [@slide]="{
      value: percent,
      params: {
        previousPercent: previousPercent
      }
    }"
    [style.backgroundColor]="color"
    [style.width.%]="percent">
  </div>
</ng-template>
